module.exports = __webpack_public_path__ + "static/1-acc9b6c65ec53cee5dd1fb137f18a488.png";